'use client';

import Message from '../Message';

export default class Messenger {
  public static isSupport = typeof window !== 'undefined' && (window as any)?.ReactNativeWebView;

  public static sendMessage(message: Message) {
    if (!message.isValid()) {
      throw new Error('Message is not valid');
    }

    if ((window as any)?.ReactNativeWebView?.postMessage) {
      (window as any).ReactNativeWebView.postMessage(message.toJSON());
    }
  }

  public static receiveMessage(callback: (message: Message) => void) {
    const _cb = (event: MessageEvent) => {
      // 過濾插件
      if (Object.keys(event.data).includes('wappalyzer')) {
        return;
      }
      if (typeof event.data !== 'string') {
        return;
      }
      try {
        const parsedData = JSON.parse(event.data);
        const message = new Message(parsedData.type, parsedData.data);
        callback(message);
      } catch {
        const message = new Message('error', 'parse error');
        callback(message);
      }
    };

    window.addEventListener('message', _cb);
    // @ts-expect-error 這邊是為了兼容 webview 的 message 事件
    document.addEventListener('message', _cb);

    return () => {
      window.removeEventListener('message', _cb);
      // @ts-expect-error 這邊是為了兼容 webview 的 message 事件
      document.removeEventListener('message', _cb);
    };
  }
}
